// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"808e57ca","455":"cbafcdf3","977":"ade06f15"}[chunkId] + ".chunk.js";
};